
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.8351 8.82453L8.57129 17.0883C6.9832 18.6764 4.44977 18.7155 2.90999 17.1758C1.37021 15.636 1.40934 13.1026 2.99743 11.5145L11.9798 2.53207C12.9715 1.54042 14.5566 1.51594 15.5181 2.47743C16.4796 3.43892 16.4551 5.02408 15.4635 6.01574L7.91827 13.5609C7.52305 13.9562 6.88615 13.966 6.50295 13.5828C6.11975 13.1996 6.12958 12.5627 6.52481 12.1675L13.3514 5.34086L12.3063 4.29576L5.47971 11.1224C4.48805 12.114 4.46357 13.6992 5.42506 14.6607C6.38655 15.6222 7.97172 15.5977 8.96337 14.606L16.5086 7.06084C18.0967 5.47275 18.1358 2.93932 16.596 1.39954C15.0562 -0.140238 12.5228 -0.101112 10.9347 1.48697L1.95233 10.4694C-0.23219 12.6539 -0.285961 16.1356 1.83211 18.2536C3.95018 20.3717 7.43187 20.3179 9.61639 18.1334L17.8802 9.86963L16.8351 8.82453Z"}})])
          )
        }
      }
    